import React from 'react';
import Logo from "../../components/logo/Logo";
import close from '../../assets/img/close.png';
import './Modal.css';

class Modal extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            animationLoaded: false,
            fullScreen: false,
        };

        window.resizeTo(500, 500);
        window.innerWidth = 500;
        window.innerHeight = 500;
    }

    showOnFullScreen = event => {
        event.preventDefault();
        event.stopPropagation();
        let isInFullScreen = (document.fullscreenElement && document.fullscreenElement !== null) ||
            (document.webkitFullscreenElement && document.webkitFullscreenElement !== null) ||
            (document.mozFullScreenElement && document.mozFullScreenElement !== null) ||
            (document.msFullscreenElement && document.msFullscreenElement !== null);
        if (isInFullScreen) {
            if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.webkitExitFullscreen) {
                document.webkitExitFullscreen();
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            } else if (document.msExitFullscreen) {
                document.msExitFullscreen();
            }
        } else {
            let elem = document.getElementById("modal_window");
            if (elem.requestFullscreen) {
                elem.requestFullscreen();
            } else if (elem.mozRequestFullScreen) { /* Firefox */
                elem.mozRequestFullScreen();
            } else if (elem.webkitRequestFullscreen) { /* Chrome, Safari & Opera */
                elem.webkitRequestFullscreen();
            } else if (elem.msRequestFullscreen) { /* IE/Edge */
                elem.msRequestFullscreen();
            }
        }
    };

    render() {
        return (
            <div
                className="modal-backdrop"
                onClick={
                    this.props.onCloseModal
                }
            >
                <div
                    className="modal-parent"
                >
                    <div
                        id="modal_window"
                        className="modal-modal"
                    >
                        <p onClick={event => this.showOnFullScreen(event)}><i className="material-icons">fullscreen</i>
                        </p>

                        <img src={close}
                            style={{
                                background: '#fff',
                                width: '1.5em',
                                height: '1.5em',
                                position: 'absolute',
                                pointer: 'cursor',
                                zIndex: '5000',
                                top: '1em',
                                right: '1em',
                                cursor: 'pointer',
                            }}
                            onClick={
                                this.props.onCloseModal
                            }
                        />
                        <div class="iframe-container"
                         style={{
                            float: 'left',
                            zIndex: '4000',
                            display: this.state.animationLoaded ? 'block' : 'none'
                        }}>
                            <iframe
                                class="responsive-iframe"
                                id="animationIframe"
                              
                                onLoad={() => {
                                    this.animationLoaded()
                                }}
                                src={this.props.link}
                            />
                        </div>
                        <div
                            style={{
                                width: '100%',
                                justifyContent: 'center',
                                alignItems: 'center',
                                display: !this.state.animationLoaded ? 'block' : 'none'
                            }}
                        >
                            <Logo
                                // height={this.props.height}
                                style={{
                                    padding: '1em',
                                    overflow: 'hidden',
                                    display: !this.state.animationLoaded ? 'block' : 'none'
                                }}
                            />
                        </div>

                    </div>
                </div>
            </div>
        )
    }

    animationLoaded = () => {
        this.setState({ animationLoaded: true });
    }
}

export default Modal;



// WEBPACK FOOTER //
// ./src/UI/Modal/Modal.js